import schemaLdJson from 'src/seo/schemaLdJson'

export default class extends schemaLdJson {
  constructor($this) {
    super($this)
    this.$this = $this
  }

  author() {
    return {
      '@type': 'Organization',
      name: this.$this.getGameObjectData.manufacturer.code,
      url: `${this.URL}/ru/games/${this.$this.getGameObjectData.manufacturer.code}`,
      logo: {
        '@type': 'ImageObject',
        url: `${this.URL}${this.$this.getGameObjectData.manufacturer.image}`,
        width: '186',
        height: '73',
      },
    }
  }

  capitalizeProvider() {
    const code = this.$this.getGameObjectData.manufacturer.code

    return code ? code.charAt(0).toUpperCase() + code.slice(1) : ''
  }

  generate() {
    const $this = this.$this

    const image = $this.getGameObjectData.compressedImage
      ? $this.getGameObjectData.compressedImage.webp?.md ?? null
      : null

    const json = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      url: `${this.URL}/ru/games/${$this.getGameObjectData.manufacturer.code}/${$this.getGameObjectData.slug}`,
      name: $this.getGameObject.game.name,
      datePublished: $this.getGameObjectData.created,
      dateModified: $this.getGameObjectData.updated,
      description: $this.metaDesc,
      isPartOf: this.isPartOf(),
      publisher: this.publisher(),
      potentialAction: {
        '@type': 'PlayAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${this.URL}/ru/games/${$this.getGameObjectData.manufacturer.code}/${$this.getGameObjectData.slug}`,
          actionApplication: {
            '@type': 'SoftwareApplication',
            name: $this.getGameObjectData.name,
            image: '',
            description: `Игровой автомат ${$this.getGameObjectData.name} от провайдера ${$this.getGameObjectData.manufacturer.code}. Это бесплатная демо версия - в нее можно играть без регистрации в онлайн-казино Олимп. Желаем вам приятной игры!`,
            applicationCategory: 'Game',
            applicationSubCategory: 'Slot Machine',
            genre: ['Slots', 'Online Slots', 'Casino Game'],
            datePublished: $this.getGameObjectData.created,
            processorRequirements: '1 GHz',
            memoryRequirements: '1 Gb',
            storageRequirements: '2 Gb',
            operatingSystem: ['Multi-platform', 'Windows', 'Andorid', 'IOS', 'Linux'],

            author: this.author(),
          },
        },
      },
      mainEntity: {
        '@type': 'VideoGame',
        name: $this.getGameObjectData.name,
        image: '',
        description: `Игровой автомат ${$this.getGameObjectData.name} от провайдера ${$this.getGameObjectData.manufacturer.code}. Это бесплатная демо версия - в нее можно играть без регистрации в онлайн-казино Олимп. Желаем вам приятной игры!`,
        inLanguage: this.inLanguage,
        applicationCategory: 'Game',
        applicationSubCategory: 'Slot Machine',
        genre: ['Slots', 'Online Slots', 'Casino Game'],
        datePublished: $this.getGameObjectData.created,
        playMode: 'SinglePlayer',
        processorRequirements: '1 GHz',
        memoryRequirements: '1 Gb',
        storageRequirements: '2 Gb',
        gamePlatform: ['Browser', 'Flash', 'HTML5', 'PC game', 'Andorid', 'IOS'],
        operatingSystem: ['Multi-platform', 'Windows', 'Andorid', 'IOS', 'Linux'],
        author: this.author(),
        translator: this.translator(),
        publisher: this.publisher(),
      },

      breadcrumb: this.breadcrumb([
        {
          type: 'Thing',
          '@id': `${this.URL}/ru/games/${$this.getGameObjectData.manufacturer.code}/`,
          name: `⚡${this.capitalizeProvider()}`,
        },
        {
          type: 'WebPage',
          '@id': `${this.URL}/ru/games/${$this.getGameObjectData.manufacturer.code}/${$this.getGameObjectData.slug}`,
          name: `🎰${$this.getGameObjectData.name}`,
        },
      ]),
    }

    if (image) {
      const finalImage = `${this.URL}/${image}`
      json.primaryImageOfPage = {
        '@type': 'ImageObject',
        url: finalImage,
        contentUrl: finalImage,
        width: '240',
        height: '160',
      }
      json.potentialAction.target.actionApplication.image = finalImage
      json.mainEntity.image = finalImage
    }

    return JSON.stringify(json)
  }
}
